<template>
    <div class="anyPayDetail_box">
      <div class="DetailTop">
        <div class="topL">订单ID：{{orderInfoObj.id}}</div>
        <div class="topR">
          <span>状态：</span>
          <div class="circleBox"> {{orderInfoObj.status}}</div>
        </div>
      </div>
      <div class="restaurantList">
        <div class="listBox">
          <div class="blueLind"></div>
          <div class="vipCheckBox">
            <div class="infoBo">
              <span>基本信息</span>
            </div>
          </div>
          <div class="infoDetail clearfix">
            <ul>
              <li>
                <p><label>收款账号：</label>{{orderInfoObj.accont}}</p>
                <p style="color:red"><label>金额：</label>{{orderInfoObj.totalMoney}}</p>
              </li>
              <li>
                <p><label>费用代码：</label>{{orderInfoObj.feeCode}}</p>
                <p><label>费用名称：</label>{{orderInfoObj.feeName}}</p>
              </li>
             <li>
                <p><label>付款代码：</label>{{orderInfoObj.payCode}}</p>
                <p><label>付款方式：</label>{{orderInfoObj.taWay | payWayf}}</p>
              </li>
             
              <li>
                <p><label>支付金额：</label>{{orderInfoObj.payMoney}}</p>
           
              </li>
               <li class="p100">
                <p class="p100"><label>支付时间：</label>{{orderInfoObj.payDate}}</p>
              </li>
               <li class="p100">
                <p class="p100"><label>订单号：</label>{{orderInfoObj.orderNo}}</p>
              </li>
              <!-- <li class="p100">
                <p class="p100"><label>支付单号：</label>{{orderInfoObj.taOrderNo}}</p>
              </li> -->
              <li class="p100"> 
                <p class="p100"><label>{{SYS_DEVICE=="ICBC"?"参考号":"凭证号"}}：</label>{{orderInfoObj.taNo | fitOrderNo}}</p>
              </li>     
            <li v-if="orderInfoObj.cancelDate">
                <p><label>撤消金额：</label>{{orderInfoObj.cancelMoney}}</p>
               
              </li>
              <li v-if="orderInfoObj.cancelDate">
                <p><label>撤消人：</label>{{orderInfoObj.cancelUserCode}}</p>
                <p><label>撤消凭证：</label>{{orderInfoObj.remark}}</p>
              </li>
               <li class="p100" v-if="orderInfoObj.cancelDate">
                <p class="p100"><label>撤消时间：</label>{{orderInfoObj.cancelDate}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="listBox clearBottom">
          <div class="blueLind"></div>
          <div class="vipCheckBox">
            <div class="infoBo">
              <span>更多信息</span>
            </div>
          </div>
          <div class="infoDetail clearfix" style="margin-bottom:40px">
            <ul>
              <li>
                <p><label>创建人：</label>{{orderInfoObj.createUser}}</p>
               
              </li>
                <li class="p100">
                <p  class="p100"><label>创建时间：</label>{{orderInfoObj.createDate}}</p>
              </li>
                  <li class="p100">
               <p class="p100"><label>修改人：</label>{{orderInfoObj.modifyUser}}</p>
               </li>
              <li class="p100">
                <p  class="p100"><label>修改时间：</label>{{orderInfoObj.modifyDate}}</p>
              </li>
                <li class="p100">
                <p class="p100" style="word-break:break-all"><label>支付数据包：</label>
                <span v-if="!disdetail" @click="disdetail=true">[查看]</span>
                <span v-else>{{orderInfoObj.taBody}}</span></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import { payWay } from '../../assets/js/anypay';
export default {
  data() {
    return {
      orderInfoObj: "",
      SYS_DEVICE:"",
      disdetail:false,
    };
  },
  props: {},
  methods: {
    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    getMasterList(id) {
      if (id == undefined) {
        return;
      }
      this.disdetail = false;
      var url = "/mobilepmsapi/pay/getDetail?id=" + id;
      this.$http.post(url).then(res => {
        if (res.data.result == 0) {
          this.orderInfoObj = res.data.retVal;
        } else {
          this.msg(res.data.msg);
        }
      });
    }
  },
  filters: {
    payWayf(v){
      return payWay(v);
    },
     fitOrderNo(v){
         return (v != null && v.indexOf("_") > 0) ?  v.split('_')[0]:v;
      }
  },
  mounted() {
    this.SYS_DEVICE = this.$SYS_DEVICE;
  }
};
</script>
<style lang="less">
.anyPayDetail_box {
  overflow: auto;
  height: 100%;
  .DetailTop {
    width: 90%;
    height: 1.2533rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #333333;
    .topL {
      float: left;
      line-height: 1.2267rem;
    }
    .topR {
      float: right;
      line-height: 1.2267rem;
      span {
        display: inline-block;
      }
      .circleBox {
        width: 0.64rem;
        height: 0.64rem;
        background: #646f83;
        border-radius: 1.36rem;
        color: #fff;
        display: inline-block;
        vertical-align: top;
        margin-top: 0.3733rem;
        line-height: 0.5867rem;
      }
    }
  }
  .restaurantList {
    background: #ffffff;
    margin-bottom: 0.2667rem;
    width: 96%;
    height: auto;
    margin: 0 auto 0.2667rem;
    box-shadow: 0 0 0.2133rem 0rem #dadada;
    border-radius: 0.1333rem;
    .listBox {
      width: 100%;
      height: auto;
      padding-bottom: 0.2667rem;
      border-bottom: 0.0267rem dashed #eeeeee;
      .blueLind {
        height: 0.3733rem;
        width: 1.1%;
        background: #646f83;
        float: left;
        margin-top: 0.4rem;
      }
      .infoDetail {
        width: 90%;
        margin: 0 auto;
        text-align: left;
        margin-top: 0.2667rem;
        font-size: 0.35rem;
        color: #333333;
        ul {
          li {
            p {
              width: 50%;
              margin: 0.1rem auto;
              float: left;
            }
          }
          .p100 {
            width: 100%;
            clear: both;
          }
        }
        .tablList {
          li {
            float: left;
            margin-right: 8px;
            text-decoration: underline;
            color: #4990e2;
          }
        }
        .infoL {
          width: 50%;
          height: auto;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          float: left;
        }
        .infoR {
          width: 50%;
          height: auto;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          float: right;
        }
      }
      .vipCheckBox {
        width: 94.5%;
        margin: 0 auto;
        padding-top: 0.2933rem;
        .infoBo {
          text-align: left;
          margin-left: 0.08rem;
          span {
            font-weight: bold;
            margin-left: 0.1333rem;
            font-size: 0.3733rem;
            color: #151515;
          }
        }
      }
    }
    .clearBottom {
      border-bottom: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// anypayMasterList.vue?33aecf6c